module.exports = __webpack_public_path__ + "static/media/all3d-new-logo-red.50b341b6.svg";